/* Nune Process page: scroll reveal, mouse and scroll depth, gentle tilt, videos that play on screen, and the steps rail. */
(function () {
  'use strict';
  var KEY = '__npg_npr';
  if (window[KEY]) return;
  window[KEY] = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasIO = 'IntersectionObserver' in window;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  /* reveal on scroll */
  var revealIO = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: .08 }) : null;

  /* videos play only while on screen */
  var videoIO = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && v.offsetParent !== null) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: .2 }) : null;

  /* depth: everything marked data-depth drifts with the mouse and the scroll */
  var depthEls = [], mx = 0, my = 0, tx = 0, ty = 0, raf = 0;
  function frame() {
    mx += (tx - mx) * .08; my += (ty - my) * .08;
    var vh = window.innerHeight;
    depthEls.forEach(function (el) {
      var host = el.parentElement || el;
      var r = host.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var sp = clamp(((r.top + r.height / 2) - vh / 2) / vh, -1.2, 1.2);
      el.style.setProperty('--sy', sp.toFixed(3));
      el.style.setProperty('--mx', mx.toFixed(3));
      el.style.setProperty('--my', my.toFixed(3));
    });
    raf = Math.abs(tx - mx) + Math.abs(ty - my) > .002 ? requestAnimationFrame(frame) : 0;
  }
  function kick() { if (!raf && depthEls.length) raf = requestAnimationFrame(frame); }
  if (!reduce) {
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
    if (fine) window.addEventListener('pointermove', function (e) {
      tx = e.clientX / window.innerWidth * 2 - 1; ty = e.clientY / window.innerHeight * 2 - 1; kick();
    }, { passive: true });
  }

  function initTilt(el) {
    if (reduce || !fine) return;
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--tx', (((e.clientX - r.left) / r.width - .5) * 8).toFixed(2) + 'deg');
      el.style.setProperty('--ty', (((e.clientY - r.top) / r.height - .5) * -8).toFixed(2) + 'deg');
    });
    el.addEventListener('pointerleave', function () { el.style.setProperty('--tx', '0deg'); el.style.setProperty('--ty', '0deg'); });
  }

  function initSteps(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    if (!steps.length) return;
    var num = root.querySelector('[data-step-num]'), now = root.querySelector('[data-step-title]');
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-step-link]'));
    var cur = -1, sraf = 0;
    function set(i) {
      cur = i;
      var s = steps[i];
      root.style.setProperty('--sc', s.getAttribute('data-color'));
      if (num) num.textContent = pad(i + 1);
      if (now) now.textContent = s.getAttribute('data-title');
      links.forEach(function (a, j) { if (j === i) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current'); });
    }
    function measure() {
      sraf = 0;
      var mid = window.innerHeight * .5, best = 0, bd = Infinity;
      steps.forEach(function (s, i) {
        var r = s.getBoundingClientRect(), d = Math.abs(r.top + r.height / 2 - mid);
        if (d < bd) { bd = d; best = i; }
      });
      var a = steps[0].getBoundingClientRect(), b = steps[steps.length - 1].getBoundingClientRect();
      root.style.setProperty('--p', clamp((mid - a.top) / Math.max(1, b.bottom - a.top), 0, 1).toFixed(3));
      if (best !== cur) set(best);
    }
    function onScroll() { if (!sraf) sraf = requestAnimationFrame(measure); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    links.forEach(function (a, j) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        steps[j].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
    root.__goStep = function (j) { steps[j].scrollIntoView({ behavior: 'auto', block: 'center' }); };
    measure();
  }

  function init(root) {
    if (root.__npg) return;
    root.__npg = true;
    root.classList.add('is-js');
    each(root, '[data-reveal]', function (el) { if (reduce || !revealIO) el.classList.add('is-in'); else revealIO.observe(el); });
    each(root, '[data-video] video', function (v) {
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('autoplay');
      if (reduce || !videoIO) { v.controls = true; return; }
      videoIO.observe(v);
    });
    if (!reduce) each(root, '[data-depth]', function (el) { depthEls.push(el); });
    each(root, '[data-tilt]', initTilt);
    if (root.hasAttribute('data-steps')) initSteps(root);
    kick();
  }

  function initAll(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-npr]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var step = e.target.closest && e.target.closest('[data-step]');
    var root = step && step.closest('[data-steps]');
    if (root && root.__goStep) root.__goStep(Array.prototype.indexOf.call(root.querySelectorAll('[data-step]'), step));
  });
})();
